import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';

export const CarouselChild = styled.div<any>`
  width: 50%;
`;

export const CarouselContentWrapper = styled.div<any>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;
  left: ${({ index, count = 1 }: any) => (-index * 100) / count}%;
  width: ${({ length }: any) => length * 100}%;
  transition: 380ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;

export const CarouselWrapper = styled.div<any>`
  position: relative;
  overflow: hidden;
`;

export const CarouselImageWrapper = styled.div<any>`
  position: relative;
`;

export const useCarouselSlider = (length, duration) => {
  const [activePageIndicator, setActivePageIndicator] = useState(0);

  useEffect(() => {
    if (!duration) {
      return;
    }
    const interval = setInterval(() => {
      setActivePageIndicator((prev) => (prev + 1) % length);
    }, duration);

    return () => clearInterval(interval);
  }, []);

  const handlePrevious = () => {
    setActivePageIndicator((prev) => (prev === 0 ? length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActivePageIndicator((prev) => (prev + 1) % length);
  };

  return {
    setActivePageIndicator,
    activePageIndicator,
    handlePrevious,
    handleNext,
  };
};
